var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChartColumn = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "lucide lucide-chart-column-icon lucide-chart-column",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 3v16a2 2 0 0 0 2 2h16"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 17V9"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M13 17V5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M8 17v-3"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChartColumn);
export { ForwardRef as ReactComponent };